<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount">
        {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Dinheiro adicionado</strong><br />
        Pix
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>

    <div class="c-base-transaction-details__body">
      <div class="c-base-transaction-details__footer">
        <p class="is-size-6">
          Código da transação
          <br />
          <strong>
            {{ transaction.transaction_id }}
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'
import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

export default {
  mixins: [BaseTransactionDetailsMixin, verifyDataUserMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: String,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    transactionsLoadeds: {
      get() {
        return this.$store.state.wallet.transactionsLoadeds
      },
      set(payload) {
        this.$store.dispatch('setTransactionsLoadeds', payload)
      },
    },
  },

  methods: {
    emitReferenceTransaction() {
      this.$emit('open-reference')
    },

    userValidateToRedirect(params, redirectTypeName, cashback_id) {
      if (this.verifyDataUser()) {
        this.goTo(params, redirectTypeName, cashback_id)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>
